import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { ConfigService } from 'src/app/services/application/config.service.';
import { Utils } from 'src/app/services/utils';
import { IDoctor, IServ } from '../../../interfaces/record.interfaces';

@Component({
    selector: 'app-doctor-card',
    templateUrl: './doctor-card.component.html',
    styleUrls: ['./doctor-card.component.scss'],
    standalone: false
})
export class DoctorCardComponent implements OnInit, OnDestroy {
    @Input() public doctor!: IDoctor;
    @Input() public isActive: boolean = false;
    @Input() public openSelectStates: { [key: number]: boolean } = {};
    @Input() public selectedSrvMap: { [key: number]: IServ } = {};
    @Input() public searchStrSrv: { [doctorId: number]: any } = {};
    @Input() public isMobile: boolean = false; // Получаем значение из родительского компонента

    @Output() public serviceSelected = new EventEmitter<{
        service: IServ;
        doctor: IDoctor;
    }>();
    @Output() public toggleSelectEvent = new EventEmitter<number>();
    @Output() public searchSrvChanged = new EventEmitter<{
        searchText: string;
        doctorId: number;
    }>();
    @Output() public openDocInfo = new EventEmitter<{
        doctor: IDoctor;
        event: Event;
    }>();
    @Output() public openServDesc = new EventEmitter<{
        service: IServ;
        event: Event;
    }>();
    @Output() public openMobileServiceListEvent = new EventEmitter<{
        doctor: IDoctor;
        event: Event;
    }>();
    @Output() public pickDoc = new EventEmitter<{
        doctor: IDoctor;
    }>();

    public showMobileServiceList: boolean = false;
    private mediaQuery: MediaQueryList | undefined;
    private mediaQueryListener:
        | ((this: MediaQueryList, ev: MediaQueryListEvent) => any)
        | null = null;

    public constructor(private configS: ConfigService) {}

    public ngOnInit(): void {
        // Если isMobile не передан извне, определяем его самостоятельно
        // if (this.isMobile === undefined) {
        this.initMobileCheck();
        // }
    }

    public ngOnDestroy(): void {
        // Очистка слушателя при уничтожении компонента
        if (this.mediaQueryListener) {
            this.mediaQuery?.removeListener(this.mediaQueryListener);
        }
    }

    /**
     * Инициализирует проверку на мобильное устройство
     */
    private initMobileCheck(): void {
        // Создаем медиа-запрос для проверки ширины экрана
        this.mediaQuery = window.matchMedia('(max-width: 767px)');

        // Создаем слушатель изменений медиа-запроса
        this.mediaQueryListener = (e) => {
            this.isMobile = e.matches;
        };

        // Добавляем слушатель
        this.mediaQuery.addListener(this.mediaQueryListener);

        // Устанавливаем начальное значение
        this.isMobile = this.mediaQuery.matches;
    }

    /**
     * Открывает мобильный список услуг
     * @param event Событие клика
     */
    public openMobileServiceList(event: Event): void {
        event.stopPropagation();
        if (this.doctor.srvList && this.doctor.srvList.length > 0) {
            this.showMobileServiceList = true;
            this.openMobileServiceListEvent.emit({
                doctor: this.doctor,
                event,
            });
        }
    }

    /**
     * Закрывает мобильный список услуг
     */
    public closeMobileServiceList(): void {
        this.showMobileServiceList = false;
    }

    /**
     * Обрабатывает выбор услуги в мобильном списке
     * @param service Выбранная услуга
     */
    public onMobileServiceSelected(service: IServ): void {
        this.selectService(service, this.doctor);
        this.closeMobileServiceList();
    }

    public experienceText(exp: string): string {
        return Utils.experienceText(exp);
    }

    public getFioDoc(doctor: IDoctor): string {
        if (!doctor || !doctor.lName || !doctor.fName) return '';
        return `${doctor.lName} ${doctor.fName} ${doctor.sName || ''}`;
    }

    public toggleSelect(doctorId: number) {
        this.toggleSelectEvent.emit(doctorId);
    }

    public changeSearchSrv(searchText: string, doctorId: number) {
        this.searchSrvChanged.emit({ searchText, doctorId });
    }

    public selectService(service: IServ, doctor: IDoctor) {
        this.serviceSelected.emit({ service, doctor });
    }

    public openDocInfoModal(doctor: IDoctor, event: Event) {
        event.stopPropagation();
        this.openDocInfo.emit({ doctor, event });
    }

    public openServDescModal(service: IServ, event: Event) {
        event.stopPropagation();
        this.openServDesc.emit({ service, event });
    }

    public rcountText(count: number): string {
        if (!count) return 'Нет номерков';

        const lastDigit = count % 10;

        let verb = 'Свободно';
        let ending = 'номерков';

        if (lastDigit === 1) {
            verb = 'Свободен';
            ending = 'номерок';
        } else if (lastDigit >= 2 && lastDigit <= 4) {
            ending = 'номерка';
        }

        return `${verb} ${count} ${ending}`;
    }
    public getImgSrcDoc(id: number): string {
        return `${this.configS.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    public getDocImgDefault(event: Event) {
        // const elem = event.target as HTMLImageElement;
        // elem.src = `${this.configS.getValue('hostBackend')}/img/doc/not.png`;
        const elem = event.target as HTMLImageElement;
        elem.src = './assets/images/placeholders/doctor-photo.png';
    }

    public async onFilterChanged(event: any) {
        switch (event.typeEvent) {
            case 'srvPicked':
        }
        this.serviceSelected.emit({
            service: event,
            doctor: this.doctor,
        });

        this.showMobileServiceList = false;
    }

    public showSrvHandler(event: any, doctor: IDoctor) {
        event.stopPropagation();
        this.serviceSelected.emit({
            service: event.data,
            doctor: this.doctor,
        });
    }

    public pickDoctorHandler(doctor: IDoctor) {
        this.pickDoc.emit({
            doctor: doctor,
        });
    }
}
